module.exports = __webpack_public_path__ + "static/media/QD.4cedc6a2.svg";